export default __webpack_public_path__ + "static/media/bootstrap-grid.css.81d417bb.map";